

/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";
// incrementQuantity
// INCREMENTQUANTITY
const INCREMENTQUANTITY= createAsyncThunk(
  "incrementQuantity/incrementQuantity",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const incrementQuantitySlice = createSlice({
  name: "incrementQuantitySlice",
  initialState: {
    incrementQuantity: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfincrementQuantity: (state) => {
        state.incrementQuantity.loading = false
        state.incrementQuantity.error = false
        state.incrementQuantity.data = []
        state.incrementQuantity.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(INCREMENTQUANTITY.fulfilled, (state, action) => {
      state.incrementQuantity = {
        ...state.incrementQuantity,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(INCREMENTQUANTITY.pending, (state, action) => {
      state.incrementQuantity = {
        ...state.incrementQuantity,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(INCREMENTQUANTITY.rejected, (state, action) => {
      state.incrementQuantity = {
        ...state.incrementQuantity,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const incrementQuantityAction = {
    INCREMENTQUANTITY,
};

export { incrementQuantityAction };
export default incrementQuantitySlice.reducer;
export const {setInitialStateOfincrementQuantity} = incrementQuantitySlice.actions
